import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export async function getCambioLada(filters: any) {
  const params = new URLSearchParams();

  if (filters.user_id) params.set('user_id', filters.user_id);
  if (filters.init_date) params.set('init_date', filters.init_date);
  if (filters.end_date) params.set('end_date', filters.end_date);
  if (filters.rol_id) params.set('rol_id', filters.rol_id);
  if (filters.search) params.set('search', filters.search);

  const response = await axios.get(
    `${API_URL}reports/lada-movements?${params.toString()}`
  );
  const data = response.data.doc.data.rows;
  return data;
}

export async function downloadPDF(filters: any) {
  const params = new URLSearchParams();
  const date = new Date().toISOString().split('T')[0];

  if (filters.user_id) params.set('user_id', filters.user_id);
  if (filters.init_date) params.set('init_date', filters.init_date);
  if (filters.end_date) params.set('end_date', filters.end_date);
  if (filters.rol_id) params.set('rol_id', filters.rol_id);

  try {
    const response = await axios({
      url: `${API_URL}reports/lada-movements/document/pdf?${params.toString()}`,
      method: 'GET',
      responseType: 'blob',
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `REPORTE-CAMBIO-DE-LADA-${date}.pdf`);
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 0);

    return false;
  } catch (error: any) {
    return JSON.parse(await error.response.data.text());
  }
}

export async function downloadExcel(filters: any) {
  const params = new URLSearchParams();
  const date = new Date().toISOString().split('T')[0];

  if (filters.init_date) params.set('init_date', filters.init_date);
  if (filters.end_date) params.set('end_date', filters.end_date);
  if (filters.user_id) params.set('user_id', filters.user_id);
  if (filters.rol_id) params.set('rol_id', filters.rol_id);

  try {
    const response = await axios({
      url: `${API_URL}reports/lada-movements/document/excel?${params.toString()}`,
      method: 'GET',
      responseType: 'blob',
    });

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `REPORTE-CAMBIO-DE-LADA-${date}.xlsx`);
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 0);

    return false;
  } catch (error: any) {
    return JSON.parse(await error.response.data.text());
  }
}
